/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

import { BaSeIcon } from '@base/react';
import card1 from '../../assets/image-video-1.png';
import card10 from '../../assets/image-video-10.png';
import card11 from '../../assets/image-video-11.png';
import card12 from '../../assets/image-video-12.png';
import card13 from '../../assets/image-video-13.png';
import card2 from '../../assets/image-video-2.png';
import card3 from '../../assets/image-video-3.png';
import card4 from '../../assets/image-video-4.png';
import card5 from '../../assets/image-video-5.png';
import card6 from '../../assets/image-video-6.png';
import card7 from '../../assets/image-video-7.png';
import card8 from '../../assets/image-video-8.png';
import card9 from '../../assets/image-video-9.png';
import { useDisplay } from '../../hook/useDisplay';
import Modal from './Modal';
import {
  AlignText,
  Container,
  ContainerText,
  Content,
  ContentItem,
  ContentText,
  RoundButton,
} from './style';
import './style.css';

function Secrets() {
  const cards = [
    {
      imgCard: card1,
      linkVideoCard: 'https://www.youtube.com/embed/Uq5QpZCi6P4?enablejsapi=1',
      title: 'Veja as dicas para criar e fortalecer clientes',
    },
    {
      imgCard: card2,
      linkVideoCard: 'https://www.youtube.com/embed/XYJbHADv89E?enablejsapi=1',
      title: 'Como se reinventar e pensar na equipe, no cliente e no caixa',
    },
    {
      imgCard: card3,
      linkVideoCard: 'https://www.youtube.com/embed/tq2aC-u0K2U?enablejsapi=1',
      title:
        'Aprenda como as redes sociais podem te ajudar em momentos de crise',
    },
    {
      imgCard: card4,
      linkVideoCard: 'https://www.youtube.com/embed/-FSFJud4NPo?enablejsapi=1',
      title: 'Veja como tomar decisões para se reinventar na crise',
    },
    {
      imgCard: card5,
      linkVideoCard: 'https://www.youtube.com/embed/DcFhfxnld1A?enablejsapi=1',
      title: 'Como levar conteúdos presenciais para as plataformas digitais',
    },
    {
      imgCard: card6,
      linkVideoCard: 'https://www.youtube.com/embed/2X1LJbiI49I?enablejsapi=1',
      title:
        'Dicas para fortalecer o seu delivery e tornar sua marca acessível',
    },
    {
      imgCard: card7,
      linkVideoCard: 'https://www.youtube.com/embed/8R3WMmCxjtY?enablejsapi=1',
      title: 'Cuide do caixa, reduza custos, repactue prazos e faça parcerias',
    },
    {
      imgCard: card8,
      linkVideoCard: 'https://www.youtube.com/embed/NTabRyB3r5o?enablejsapi=1',
      title: 'Tenha dicas de como se relacionar com as equipes durante a crise',
    },
    {
      imgCard: card9,
      linkVideoCard: 'https://www.youtube.com/embed/w92I4wPUjAs?enablejsapi=1',
      title: 'Mantenha as finanças da empresa estáveis e busque por resultados',
    },
    {
      imgCard: card10,
      linkVideoCard: 'https://www.youtube.com/embed/bY3naEFqw9A?enablejsapi=1',
      title: 'Veja como ampliar o seu público e criar novas oportunidades',
    },
    {
      imgCard: card11,
      linkVideoCard: 'https://www.youtube.com/embed/zY3I6Eqho1E?enablejsapi=1',
      title:
        'Como minimizar o impacto da crise, planejar e fortalecer sua marca',
    },
    {
      imgCard: card12,
      linkVideoCard: 'https://www.youtube.com/embed/OZGtR1DP6qg?enablejsapi=1',
      title:
        'Renove seus produtos para usar as mídias digitais e redes sociais',
    },
    {
      imgCard: card13,
      linkVideoCard: 'https://www.youtube.com/embed/ryPFNzxT_DA?enablejsapi=1',
      title: 'Fortaleça o seu marketing, crie um delivery e ajude a comunidade',
    },
  ];
  const [linkSelected, setLinkSelected] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const { isLargeDisplay } = useDisplay();

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        {/* <p>{'>'}</p> */}
        <BaSeIcon
          name="system/arrow-right-s-line"
          size="18"
          description="icon-lightulb-als"
          color="#ffffff"
        />
      </RoundButton>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <RoundButton
        className={className}
        style={{ ...style, display: 'hidden' }}
        onClick={onClick}
      >
        <BaSeIcon
          name="system/arrow-left-s-line"
          size="18"
          description="icon-lightulb-als"
          color="#ffffff"
        />
      </RoundButton>
    );
  }

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    nextArrow: !isLargeDisplay() ? <></> : <SampleNextArrow />,
    prevArrow: !isLargeDisplay() ? <></> : <SamplePrevArrow />,
    customPaging: (i) => (
      <div
        style={{
          height: '5px',
          borderRadius: 100,
          backgroundColor: '#8B99A7',
        }}
      >
        ‎
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: false,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <Container id="4">
      <ContainerText>
        <p>
          Descubra os <strong>segredos</strong> para manter o seu negócio no
          caminho certo
        </p>
      </ContainerText>
      <div>
        <Slider {...settings}>
          {cards.map((item) => (
            <ContentItem>
              <Content bg={item.imgCard}>
                <ContentText>
                  <AlignText>
                    <BaSeIcon
                      color="#fff"
                      description="Ícone de play"
                      name="media/play-mini-fill"
                      onClick={() => {
                        setOpen((prev) => !prev);
                        setLinkSelected(item.linkVideoCard);
                      }}
                      size={52}
                    />
                  </AlignText>
                  <p>{item.title}</p>
                </ContentText>
              </Content>
            </ContentItem>
          ))}
        </Slider>
      </div>
      <Modal open={open} link={linkSelected} onClose={() => setOpen(false)} />
    </Container>
  );
}

export default Secrets;
